<div [ngClass]="'size-' + size" class="progress bg-secondary">
  <div
    class="progress-bar"
    role="progressbar"
    [style]="{
      width: widthPercentage + '%',
      'background-color': backgroundColor,
    }"
  ></div>
</div>
